<template>
  <BaseDrawer
    shrink
    :is-open="isOpen"
    @close="handleCloseDialog"
  >
    <template #title>
      <template v-if="product">{{ product.name }}</template>
    </template>

    <div
      class="flex flex-1 flex-col justify-end overflow-y-auto"
    >
      <CustomAmountDisplay :value="price" class="mb-6" />
      <BaseNumpad v-model="price" />
    </div>
    <div
      class="flex shrink-0 items-center justify-center p-8"
    >
      <ActionButtonPrimary
        class="w-full"
        @click="handleClickAddToCart"
      >
        Add To Cart
      </ActionButtonPrimary>
    </div>
  </BaseDrawer>
</template>

<script setup lang="ts">
import type { Product } from "@/services/sharedTypes/products"

export type VariablePriceModalPayload = {
  product: Product | null
  price: number
}

const props = defineProps<{
  product: Product | null
  isOpen: boolean
}>()

const emit = defineEmits<{
  (eventName: "update:isOpen", value: boolean): void
  (
    eventName: "ok",
    payload: VariablePriceModalPayload
  ): void
}>()

const price = ref(0)
const handleClickAddToCart = () => {
  emit("ok", { product: props.product, price: price.value })
  price.value = 0
}

const handleCloseDialog = () => {
  price.value = 0
  emit("update:isOpen", false)
}
</script>
